import "../components/global.js";
import "../assets/css/bootstrap.css";
import Navbar from "../components/Navbar";
import Select from "react-select";
import {
  tokens,
  select_style,
  alert_2,
  GET,
  POST,
  PUT,
  DELETE,
  format_date,
  number,
  float,
  validate,
  required,
  DatePicker,
  getStorage,
  loading,
} from "../components/CustomComponent.js";
import { report_customer_0 } from "../components/ReportCustomer00.js";
import { report_customer_1 } from "../components/ReportCustomer01.js";
import { report_customer_2 } from "../components/ReportCustomer02.js";
import { report_customer_3 } from "../components/ReportCustomer03.js";
import React, { Component } from "react";
import Pagination from "@mui/material/Pagination";
import { Modal } from "react-bootstrap";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";
import Switch from "react-switch";
import excel_file from "../assets/files/import_customer.xlsx";
import { DownloadTableExcel } from "react-export-table-to-excel";

const role = getStorage("role_detail");
const select_role = role ? role.find((item) => item.name === "customer") : null;
const view_r = !!(select_role && select_role.role[0] === 1);
const create_r = !!(select_role && select_role.role[1] === 1);
const update_r = !!(select_role && select_role.role[2] === 1);
const delete_r = !!(select_role && select_role.role[3] === 1);

const TRANSFER_OPTS = [
  { value: 1, label: "โอนกรรมสิทธิ์แล้ว" },
  { value: 2, label: "ยังไม่โอนกรรมสิทธิ์" },
  { value: 3, label: "ห้องว่าง" },
];
const BUY_OPTS = [
  { value: 1, label: "เงินสด" },
  { value: 2, label: "ผ่อนชำระกับธนาคาร" },
  { value: 3, label: "ผู้เช่าซื้อกับการเคหะแห่งชาติ" },
  { value: 4, label: "ซื้อต่อกับลูกค้าเดิม" },
  { value: 5, label: "อื่น ๆ" },
  { value: 6, label: "การเคหะแห่งชาติ" },
];
const getOpt = (opts, val) => opts.find((o) => o.value === val) || "";
const getLabel = (opts, val) => opts.find((o) => o.value === val)?.label || "-";
const fDate = (d) => (d ? format_date(d, "yyyy-mm-dd", "en") : "");

const COL_HEADERS = [
  "ชื่อ - สกุล",
  "เลขบัตรประชาชน",
  "ที่อยู่",
  "โทรศัพท์บ้าน",
  "โทรศัพท์มือถือ",
  "วันที่ส่งมอบ(ช่องกรอก)",
  "วันที่ส่งมอบ",
  "วันที่มารับมอบ(ช่องกรอก)",
  "วันที่มารับมอบ",
  "วันที่โอน(ช่องกรอก)",
  "วันที่โอน",
  "สถานะการโอน",
  "เลขที่เงินกู้",
  "วงเงินกู้",
  "เงินงวด",
  "วันที่ทำสัญญา(ช่องกรอก)",
  "วันที่ทำสัญญา",
  "ซื้ออาคารโดย",
  "อาคาร",
  "ชั้น",
  "บ้านเลขที่",
  "ขนาดห้อง (ตรม.)",
];

export default class Customer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      modal_change: false,
      modal_import: false,
      page: 1,
      filter_data_search: "",
      filter_transfer_date: "",
      filter_status_transfer: null,
      data: null,
      all: null,
      import: null,
      currentSheet: null,
      over: false,
      data_import: null,
      customer_id: "",
      full_name: "",
      id_card: "",
      address: "",
      home_phone: "",
      mobile_phone: "",
      delivery_date: "",
      receive_date: "",
      transfer_date: "",
      status_transfer: "",
      loan_number: "",
      credit_limit: "",
      installment: "",
      contract_date: "",
      status_buy_building: "",
      address_number: "",
      building: "",
      floor: "",
      room_size: "",
      ref_cause: 0,
      status_cable: false,
      common_expenses: 0,
      common_expenses_type: 0,
      equipment_maintenance_fee: 0,
      transfer_count: 0,
      not_transfer_count: 0,
      blank_room_count: 0,
    };
    this.tableRefAll = React.createRef();
  }

  async componentDidMount() {
    if (view_r) {
      loading(true);
      await this.GetSetting();
      await this.GetAll();
      loading(false);
      this.GetSummary();
    }
  }

  getApiBody = () => ({
    data_search: this.state.filter_data_search,
    transfer_date: this.state.filter_transfer_date,
    status_transfer: this.state.filter_status_transfer?.value || "",
  });

  GetAll = async () => {
    loading(true);
    let result = await GET(
      tokens,
      `v1/TH/customer-manage/filter-search/page/${this.state.page}/${getStorage(
        "project_id",
      )}`,
      this.getApiBody(),
    );
    if (result?.status) this.setState({ data: result.data });
    loading(false);
  };

  // countsOnly = true: อัปเดตเฉพาะตัวเลขสรุปตามตัวกรอง ไม่แตะ state.all (ตารางซ่อนสำหรับ "ส่งออกข้อมูลลูกค้า" คงพฤติกรรมเดิม)
  GetSummary = async (countsOnly = false) => {
    let result_all = await GET(
      tokens,
      `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`,
      this.getApiBody(),
    );
    if (result_all?.data?.data) {
      const d = result_all.data.data;
      this.setState({
        transfer_count: d.filter((e) => e.status_transfer === 1).length,
        not_transfer_count: d.filter((e) => e.status_transfer === 2).length,
        blank_room_count: d.filter((e) => e.status_transfer === 3).length,
        ...(countsOnly ? {} : { all: d }),
      });
    }
  };

  GetSetting = async () => {
    let result = await GET(
      tokens,
      "v1/TH/water-manage/detail/" + getStorage("water_id"),
      null,
    );
    if (result?.status) {
      let data = result.data.data;
      if (!data?.payment_close_time || !data?.meter_cut_date) {
        alert_2(
          "/manage-water",
          "warning",
          "แจ้งเตือน",
          "ท่านยังไม่ทำการตั้งค่าวันที่ปิดรับชำระเงินและวันที่ตัดมิเตอร์ก่อนทำการเริ่มต้นใช้งานระบบ",
        );
      }
      this.setState({
        common_expenses: data?.common_expenses,
        common_expenses_type: data?.common_expenses_type, // 0 = เหมาต่อห้อง | 1 = คิดตามขนาดห้อง
        equipment_maintenance_fee: data?.equipment_maintenance_fee,
      });
    }
  };

  GetReportData = async (type, reportName) => {
    loading(true);
    let data = this.getApiBody();
    data.status_transfer = type;
    let result = await GET(
      tokens,
      "v1/TH/customer-manage/filter-search/page/0/" + getStorage("project_id"),
      data,
    );
    if (result?.status) {
      const d = result.data.data;
      const { common_expenses, equipment_maintenance_fee, common_expenses_type } = this.state;
      if (reportName === "รายงานลูกค้าทั้งหมด") report_customer_0(d);
      else if (reportName === "รายงานลูกค้าโอนกรรมสิทธิ์")
        report_customer_1(d);
      else if (reportName === "รายงานลูกค้ายังไม่โอน")
        report_customer_2(d, common_expenses, common_expenses_type);
      else if (reportName === "รายงานห้องว่าง")
        report_customer_3(d, common_expenses, equipment_maintenance_fee, common_expenses_type);
    }
    loading(false);
  };

  CreateUpdate = async () => {
    if (
      validate(this.state, ["full_name", "building", "floor", "address_number"])
    )
      return;
    loading(true);
    const {
      modal_create,
      status_transfer,
      status_buy_building,
      credit_limit,
      installment,
      building,
      floor,
      room_size,
      ref_cause,
      ...s
    } = this.state;
    const payload = {
      full_name: s.full_name,
      id_card: s.id_card,
      address: s.address,
      home_phone: s.home_phone,
      mobile_phone: s.mobile_phone,
      delivery_date: s.delivery_date || null,
      receive_date: s.receive_date || null,
      transfer_date: s.transfer_date || null,
      status_transfer: status_transfer?.value || 0,
      loan_number: s.loan_number,
      credit_limit: Number(credit_limit),
      installment: Number(installment),
      contract_date: s.contract_date || null,
      status_buy_building: status_buy_building?.value || 0,
      address_number: s.address_number,
      building: Number(building),
      floor: Number(floor),
      room_size: Number(room_size),
      status_cable: s.status_cable,
    };

    let result = modal_create
      ? await POST(
          tokens,
          "v1/TH/customer-manage/create/" + getStorage("project_id"),
          { customer_list: [payload] },
        )
      : await PUT(tokens, "v1/TH/customer-manage/update", {
          ...payload,
          customer_id: s.customer_id,
          ref_cause: Number(ref_cause),
        });

    if (result?.status)
      alert_2(
        "/customer",
        "success",
        "สำเร็จ",
        modal_create
          ? "เพิ่มข้อมูลลูกค้าสำเร็จแล้ว"
          : "แก้ไขข้อมูลลูกค้าสำเร็จแล้ว",
      );
    loading(false);
  };

  CreateImport = async () => {
    loading(true);
    let result = await POST(
      tokens,
      "v1/TH/customer-manage/create/" + getStorage("project_id"),
      { customer_list: this.state.data_import },
    );
    if (result?.status)
      alert_2("/customer", "success", "สำเร็จ", "เพิ่มข้อมูลลูกค้าสำเร็จแล้ว");
    loading(false);
  };

  Delete = async (customer_id) => {
    if (
      await alert_2(
        "",
        "info",
        "ยืนยันการลบข้อมูลลูกค้า",
        "ท่านแน่ใจว่าต้องการลบข้อมูลหรือไม่? หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้",
        "ยืนยัน",
        "ยกเลิก",
      )
    ) {
      loading(true);
      let result = await DELETE(
        tokens,
        "v1/TH/customer-manage/delete/" + customer_id,
        null,
      );
      if (result?.status)
        alert_2("/customer", "success", "สำเร็จ", "ลบข้อมูลลูกค้าสำเร็จแล้ว");
      loading(false);
    }
  };

  clear_form = () => {
    this.setState({
      modal_create: false,
      modal_update: false,
      modal_change: false,
      modal_import: false,
      page: 1,
      filter_data_search: "",
      filter_transfer_date: "",
      filter_status_transfer: null,
      import: null,
      currentSheet: null,
      over: false,
      data_import: null,
      full_name: "",
      id_card: "",
      address: "",
      home_phone: "",
      mobile_phone: "",
      delivery_date: "",
      receive_date: "",
      transfer_date: "",
      status_transfer: "",
      loan_number: "",
      credit_limit: "",
      installment: "",
      contract_date: "",
      status_buy_building: "",
      address_number: "",
      building: "",
      floor: "",
      room_size: "",
      ref_cause: 0,
    });
  };

  Import_file = (e) => {
    readFile(e.target.files[0])
      .then((data) => {
        this.setState({ import: data });
        setTimeout(this.Import, 10);
      })
      .catch(console.error);
    e.target.value = "";
  };

  drop_file = (e) => {
    e.preventDefault();
    readFile(e.dataTransfer.items[0].getAsFile())
      .then((data) => {
        this.setState({ import: data });
        setTimeout(this.Import, 10);
      })
      .catch(console.error);
    this.setState({ over: false });
  };

  Import = () => {
    const sheet = this.state.currentSheet["นำเข้าข้อมูลลูกค้า"][0];
    const invalidIdx = COL_HEADERS.findIndex((col, i) => sheet[i] !== col);
    if (invalidIdx > -1) {
      alert(
        "warning",
        "แจ้งเตือน",
        `หัวคอลัมน์ "${COL_HEADERS[invalidIdx]}" ไม่ถูกต้อง`,
      );
      loading(false);
      return;
    }

    const tMap = { โอนกรรมสิทธิ์แล้ว: 1, ยังไม่โอนกรรมสิทธิ์: 2, ห้องว่าง: 3 };
    const bMap = {
      เงินสด: 1,
      ผ่อนชำระกับธนาคาร: 2,
      ผู้เช่าซื้อกับการเคหะแห่งชาติ: 3,
      ซื้อต่อกับลูกค้าเดิม: 4,
      "อื่น ๆ": 5,
    };

    let data = generateObjects(this.state.currentSheet)
      .filter((item) => item["ชื่อ - สกุล"])
      .map((item) => ({
        full_name: item["ชื่อ - สกุล"],
        id_card: item["เลขบัตรประชาชน"]
          ? ("000000" + item["เลขบัตรประชาชน"]).slice(-13)
          : "",
        address: item["ที่อยู่"],
        home_phone: (item["โทรศัพท์บ้าน"] || "").toString(),
        mobile_phone: item["โทรศัพท์มือถือ"]
          ? ("000" + item["โทรศัพท์มือถือ"]).slice(-10)
          : "",
        delivery_date: item["วันที่ส่งมอบ"] || null,
        receive_date: item["วันที่มารับมอบ"] || null,
        transfer_date: item["วันที่โอน"] || null,
        status_transfer: tMap[item["สถานะการโอน"]] || 0,
        loan_number: (item["เลขที่เงินกู้"] || "").toString(),
        credit_limit: item["วงเงินกู้"] || 0,
        installment: item["เงินงวด"] || 0,
        contract_date: item["วันที่ทำสัญญา"] || null,
        status_buy_building: bMap[item["ซื้ออาคารโดย"]] || 0,
        address_number: (item["บ้านเลขที่"] || "").toString(),
        building: item["อาคาร"],
        floor: item["ชั้น"],
        room_size: item["ขนาดห้อง (ตรม.)"],
        status_cable: false,
      }));
    data.splice(0, 1);
    this.setState({ data_import: data });
  };

  openModal = (item, type) => {
    this.setState({
      modal_update: type === "update",
      modal_change: type === "change",
      customer_id: item.customer_id,
      full_name: item.full_name,
      id_card: item.id_card,
      address: item.address,
      home_phone: item.home_phone,
      mobile_phone: item.mobile_phone,
      delivery_date: item.delivery_date,
      receive_date: item.receive_date,
      transfer_date: item.transfer_date,
      status_transfer: getOpt(TRANSFER_OPTS, item.status_transfer),
      loan_number: item.loan_number,
      credit_limit: item.credit_limit,
      installment: item.installment,
      contract_date: item.contract_date,
      status_buy_building: getOpt(BUY_OPTS, item.status_buy_building),
      address_number: item.address_number,
      building: item.building,
      floor: item.floor,
      room_size: item.room_size,
      ref_cause: type === "change" ? 2 : 0,
      status_cable: item.status_cable,
    });
  };

  // Helper สำหรับเรนเดอร์ Input ทั่วไปและ Date/Select
  renderInput = (
    label,
    field,
    isReq,
    isNum,
    isFloat,
    max,
    readOnly = false,
    cls = "validate",
  ) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">
        {label}
        {isReq && required} :
      </label>
      <input
        className={`form-control border-0 bg-contain ${cls}`}
        type={isNum ? "tel" : "text"}
        placeholder="กรอกข้อมูล"
        maxLength={max}
        value={this.state[field]}
        readOnly={readOnly}
        onChange={(e) => {
          let v = e.target.value;
          if (isNum) v = number(v);
          if (isFloat && !float(v)) return;
          this.setState({ [field]: v });
        }}
      />
    </div>
  );

  renderDate = (label, field) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">{label} :</label>
      <DatePicker
        className="form-control bg-contain border-0 w-100"
        placeholder="พิมพ์คำค้นหา..."
        value={this.state[field]}
        onChange={(e) => this.setState({ [field]: e })}
      />
    </div>
  );

  renderSelect = (label, field, opts) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">{label} :</label>
      <Select
        className="form-control bg-contain border-0 select-search"
        styles={select_style}
        options={opts}
        value={this.state[field]}
        onChange={(e) => this.setState({ [field]: e })}
      />
    </div>
  );

  render() {
    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายชื่อลูกค้า" />
        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              {/* Header & Buttons */}
              <div className="d-flex row mx-0 align-items-center justify-content-between test">
                <h4 className="mb-3">
                  <b>รายชื่อลูกค้า</b>
                </h4>
                <div className="d-flex row mx-0">
                  {view_r && (
                    <div className="d-flex flex-wrap px-0">
                      {[
                        "รายงานลูกค้าทั้งหมด",
                        "รายงานลูกค้าโอนกรรมสิทธิ์",
                        "รายงานลูกค้ายังไม่โอน",
                        "รายงานห้องว่าง",
                      ].map((txt, i) => (
                        <button
                          key={i}
                          className="btn btn-outline-primary mx-1 mb-3 text-nowarp"
                          onClick={() =>
                            this.GetReportData(i === 0 ? "" : i, txt)
                          }
                        >
                          {txt}
                        </button>
                      ))}
                    </div>
                  )}
                  {create_r && (
                    <div className="d-flex flex-wrap px-0">
                      <DownloadTableExcel
                        filename="ข้อมูลลูกค้า"
                        sheet="ข้อมูลลูกค้า"
                        currentTableRef={this.tableRefAll.current}
                      >
                        <button className="btn btn-blue px-4 mx-1 text-light mb-3 text-nowrap">
                          ส่งออกข้อมูลลูกค้า
                        </button>
                      </DownloadTableExcel>
                      <button
                        className="btn btn-blue px-4 mx-1 text-light mb-3 text-nowrap"
                        onClick={() => {
                          this.clear_form();
                          this.setState({ modal_import: true });
                        }}
                      >
                        นำเข้าข้อมูลลูกค้า
                      </button>
                      <button
                        className="btn btn-primary px-4 mx-1 mb-3 text-nowrap"
                        onClick={() => {
                          this.clear_form();
                          this.setState({ modal_create: true });
                        }}
                      >
                        เพิ่มข้อมูลลูกค้า
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Filters */}
              {view_r && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <div className="d-flex row mx-0">
                    <input
                      type="search"
                      className="form-control wpx-200 bg-contain border-0 mx-1 mb-3"
                      placeholder="ชื่อลูกค้า บ้านเลขที่..."
                      value={this.state.filter_data_search}
                      onChange={(e) =>
                        this.setState({ filter_data_search: e.target.value })
                      }
                    />
                    <div className="wpx-200 mx-1 mb-3 px-0">
                      <DatePicker
                        className="form-control bg-contain border-0"
                        placeholder="พิมพ์คำค้นหา..."
                        value={this.state.filter_transfer_date}
                        onChange={(e) =>
                          this.setState({ filter_transfer_date: e })
                        }
                      />
                    </div>
                    <div className="wpx-200 mx-1 mb-3 px-0">
                      <Select
                        className="form-control bg-contain border-0 select-search"
                        styles={select_style}
                        options={TRANSFER_OPTS}
                        value={this.state.filter_status_transfer}
                        isClearable
                        onChange={(e) =>
                          this.setState({ filter_status_transfer: e })
                        }
                      />
                    </div>
                    <button
                      className="btn btn-primary px-3 mb-3 mx-1"
                      onClick={() =>
                        this.setState({ page: 1 }, () => {
                          this.GetAll();
                          this.GetSummary(true);
                        })
                      }
                    >
                      ค้นหา
                    </button>
                    <button
                      className="btn btn-outline-primary px-3 mb-3 mx-1"
                      onClick={() =>
                        this.setState(
                          {
                            filter_data_search: "",
                            filter_transfer_date: "",
                            filter_status_transfer: "",
                            page: 1,
                          },
                          () => {
                            this.GetAll();
                            this.GetSummary(true);
                          },
                        )
                      }
                    >
                      รีเซ็ท
                    </button>
                  </div>
                </div>
              )}

              {/* Main Table */}
              <div className="table-responsive">
                {/* flex-wrap + จับคู่หัวข้อ/ตัวเลขไว้ด้วยกัน — จอแคบขึ้นบรรทัดใหม่แทนโดนตัด */}
                <div className="d-flex flex-wrap mb-3">
                  {[
                    ["หน่วยก่อสร้าง", this.state.data?.count || 0],
                    ["โอนกรรมสิทธิ์แล้ว", this.state.transfer_count],
                    ["ยังไม่โอน", this.state.not_transfer_count],
                    ["ห้องว่าง", this.state.blank_room_count],
                  ].map(([label, value]) => (
                    <span key={label} className="text-nowrap">
                      <b>{label} : </b>
                      <span className="pl-2 pr-5 text-left">{value}</span>
                    </span>
                  ))}
                </div>
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      <th className="text-nowrap text-left">อาคาร</th>
                      <th className="text-nowrap text-left">ชั้นที่</th>
                      <th className="text-nowrap text-left">บ้านเลขที่</th>
                      <th className="text-nowrap text-left">ชื่อ - นามสกุล</th>
                      <th className="text-nowrap text-center wpx-150">สถานะ</th>
                      <th className="text-nowrap text-left">วันที่โอน</th>
                      <th className="text-nowrap text-left">โทรศัพท์</th>
                      <th className="text-nowrap text-left">โทรศัพท์มือถือ</th>
                      <th className="text-nowrap text-left">เปลี่ยนสัญญา</th>
                      {(update_r || delete_r) && (
                        <th className="text-nowrap text-center">จัดการ</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {!this.state.data?.data?.length ? (
                      <tr>
                        <td colSpan={9} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      this.state.data.data.map((item, i) => (
                        <tr key={i}>
                          <td>{item.building || "-"}</td>
                          <td>{item.floor || "-"}</td>
                          <td>{item.address_number || "-"}</td>
                          <td className="text-nowrap">
                            {item.full_name || "-"}
                          </td>
                          <td className="text-center">
                            <span
                              className={`rounded px-2 py-1 text-white ${
                                item.status_transfer === 1
                                  ? "bg-primary"
                                  : item.status_transfer === 2
                                  ? "bg-purple"
                                  : "bg-blue"
                              }`}
                            >
                              {getLabel(TRANSFER_OPTS, item.status_transfer)}
                            </span>
                          </td>
                          <td>
                            {item.transfer_date
                              ? format_date(item.transfer_date)
                              : "-"}
                          </td>
                          <td>{item.home_phone || "-"}</td>
                          <td>{item.mobile_phone || "-"}</td>
                          <td className="text-center">
                            {update_r && (
                              <label className="wpx-24 hpx-24 bg-success-light rounded-1 d-flex align-items-center justify-content-center">
                                <label
                                  className="icon mx-2 text-success pointer"
                                  onClick={() => this.openModal(item, "change")}
                                >
                                  {"\uf70e"}
                                </label>
                              </label>
                            )}
                          </td>
                          {(update_r || delete_r) && (
                            <td className="text-center">
                              <div className="d-flex">
                                {update_r && (
                                  <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mr-2">
                                    <label
                                      className="icon mx-2 text-primary pointer"
                                      onClick={() =>
                                        this.openModal(item, "update")
                                      }
                                    >
                                      {"\uf304"}
                                    </label>
                                  </label>
                                )}
                                {delete_r && (
                                  <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center">
                                    <label
                                      className="icon mx-2 text-danger pointer"
                                      onClick={() =>
                                        this.Delete(item.customer_id)
                                      }
                                    >
                                      {"\uf2ed"}
                                    </label>
                                  </label>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {this.state.data?.data?.length > 0 && (
                <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                  <div>
                    <label>
                      แสดง {this.state.data.start_index} - {this.state.data.end_index} รายการ จาก{" "}
                      {this.state.data.count} รายการ
                    </label>
                  </div>
                  <Pagination
                    count={this.state.data.page_number}
                    page={this.state.page}
                    color="primary"
                    showFirstButton
                    showLastButton
                    onChange={(_e, v) =>
                      this.setState({ page: v }, this.GetAll)
                    }
                  />
                </div>
              )}

              {/* Hidden Export Table */}
              <div style={{ height: 0, opacity: 0, overflow: "hidden" }}>
                <table
                  className="table table-bordered table-hover mb-0"
                  ref={this.tableRefAll}
                >
                  <thead>
                    <tr>
                      {COL_HEADERS.map((h) => (
                        <th key={h}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.all?.map((item, i) => (
                      <tr key={i}>
                        <td>{item.full_name || ""}</td>
                        <td>{item.id_card || ""}</td>
                        <td>{item.address || ""}</td>
                        <td>{item.home_phone || ""}</td>
                        <td>{item.mobile_phone || ""}</td>
                        <td>{fDate(item.delivery_date)}</td>
                        <td>{fDate(item.delivery_date)}</td>
                        <td>{fDate(item.receive_date)}</td>
                        <td>{fDate(item.receive_date)}</td>
                        <td>{fDate(item.transfer_date)}</td>
                        <td>{fDate(item.transfer_date)}</td>
                        <td>
                          {getLabel(TRANSFER_OPTS, item.status_transfer) === "-"
                            ? ""
                            : getLabel(TRANSFER_OPTS, item.status_transfer)}
                        </td>
                        <td>{item.loan_number}</td>
                        <td>{item.credit_limit}</td>
                        <td>{item.installment}</td>
                        <td>{fDate(item.contract_date)}</td>
                        <td>{fDate(item.contract_date)}</td>
                        <td>
                          {getLabel(BUY_OPTS, item.status_buy_building) === "-"
                            ? ""
                            : getLabel(BUY_OPTS, item.status_buy_building)}
                        </td>
                        <td>{item.building}</td>
                        <td>{item.floor}</td>
                        <td>{item.address_number}</td>
                        <td>{item.room_size}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Modal Create/Update */}
        <Modal
          show={
            this.state.modal_create ||
            this.state.modal_update ||
            this.state.modal_change
          }
          onHide={() =>
            this.setState({
              modal_create: false,
              modal_update: false,
              modal_change: false,
            })
          }
          dialogClassName="modal-w"
        >
          <Modal.Header>
            <Modal.Title>
              <b>
                {this.state.modal_create
                  ? "เพิ่มข้อมูลลูกค้า"
                  : this.state.modal_change
                  ? "เปลี่ยนสัญญาเช่าซื้อ"
                  : "แก้ไขข้อมูลลูกค้า"}
              </b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 col-lg-6">
                {this.renderInput("ชื่อ-นามสกุล", "full_name", true)}
                {this.renderInput(
                  "เลขบัตรประชาชน",
                  "id_card",
                  false,
                  true,
                  false,
                  13,
                )}
                {this.renderInput("ที่อยู่", "address", false)}
                {this.renderInput(
                  "ขนาดห้อง (ตรม.)",
                  "room_size",
                  false,
                  false,
                  true,
                  13,
                )}
                {this.renderInput(
                  "โทรศัพท์บ้าน",
                  "home_phone",
                  false,
                  true,
                  false,
                  10,
                  false,
                  "",
                )}
                {this.renderInput(
                  "โทรศัพท์มือถือ",
                  "mobile_phone",
                  false,
                  true,
                  false,
                  10,
                )}
                {this.renderDate("วันที่ส่งมอบ", "delivery_date")}
                {this.renderDate("วันที่มารับมอบ", "receive_date")}
                {this.renderDate("วันที่โอน", "transfer_date")}
                <div className="w-100 d-flex align-items-center mb-3">
                  <label className="wpx-140">เก็บค่าเคเบิล :</label>
                  <Switch
                    onChange={(e) => this.setState({ status_cable: e })}
                    checked={this.state.status_cable}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                {this.renderSelect(
                  "สถานะการโอน",
                  "status_transfer",
                  TRANSFER_OPTS,
                )}
                {this.renderInput(
                  "เลขที่เงินกู้",
                  "loan_number",
                  false,
                  true,
                  false,
                  null,
                  false,
                  "",
                )}
                {this.renderInput(
                  "วงเงินกู้",
                  "credit_limit",
                  false,
                  false,
                  true,
                  null,
                  false,
                  "",
                )}
                {this.renderInput(
                  "เงินงวด",
                  "installment",
                  false,
                  false,
                  true,
                  null,
                  false,
                  "",
                )}
                {this.renderDate("วันที่ทำสัญญา", "contract_date")}
                {this.renderSelect(
                  "ซื้ออาคารโดย",
                  "status_buy_building",
                  BUY_OPTS,
                )}
                {this.renderInput(
                  "อาคาร",
                  "building",
                  true,
                  false,
                  true,
                  null,
                  this.state.modal_update,
                  "",
                )}
                {this.renderInput(
                  "ชั้น",
                  "floor",
                  true,
                  false,
                  true,
                  null,
                  this.state.modal_update,
                  "",
                )}
                {this.renderInput(
                  "บ้านเลขที่",
                  "address_number",
                  true,
                  false,
                  false,
                  null,
                  this.state.modal_update,
                  "",
                )}
              </div>
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() =>
                    this.setState({
                      modal_create: false,
                      modal_update: false,
                      modal_change: false,
                    })
                  }
                >
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-primary w-100"
                  onClick={this.CreateUpdate}
                >
                  {this.state.modal_create ? "เพิ่ม" : "บันทึก"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal Import */}
        <Modal
          show={this.state.modal_import}
          onHide={() => this.setState({ modal_import: false })}
          dialogClassName="modal-w100"
        >
          <Modal.Header>
            <Modal.Title>
              <b>นำเข้าข้อมูลลูกค้า</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!this.state.data_import && (
              <div className="w-100">
                <div className="w-100 text-right">
                  <a
                    className="text-primary mt-3"
                    href={excel_file}
                    download="import_customer.xlsx"
                  >
                    <label className="icon">{"\uf65b"}</label> template
                    นำเข้าข้อมูลลูกค้า
                  </a>
                </div>
                <div className="p-2 text-center">
                  <div
                    className={`card p-3 ${
                      this.state.over ? "bg-blue-sky" : "bg-contain"
                    } border-0 text-center mb-3`}
                    onDrop={this.drop_file}
                    onDragOver={(e) => {
                      e.preventDefault();
                      this.setState({ over: true });
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      this.setState({ over: false });
                    }}
                  >
                    <label
                      className="icon text-secondary"
                      style={{ fontSize: 48 }}
                    >
                      {"\uf65b"}
                    </label>
                    <label className="text-secondary">
                      ลากและวางไฟล์ที่นี่
                    </label>
                    <small className="text-secondary mb-3">หรือ</small>
                    <button
                      className="btn btn-primary"
                      onClick={() => document.getElementById("file").click()}
                    >
                      เลือกไฟล์
                    </button>
                  </div>
                </div>
              </div>
            )}
            <input
              className="d-none"
              type="file"
              id="file"
              accept=".xls,.xlsx"
              onChange={this.Import_file}
            />
            <div className="d-none">
              <ReactExcel
                initialData={this.state.import}
                onSheetUpdate={(s) => this.setState({ currentSheet: s })}
                activeSheetClassName="d-none"
                reactExcelClassName="table table-borderless table-striped"
              />
            </div>

            {this.state.data_import && (
              <div
                className="table-responsive"
                style={{ height: "80vh", maxHeight: "80vh" }}
              >
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {[
                        "ชื่อ - สกุล",
                        "เลขบัตรประชาชน",
                        "ที่อยู่",
                        "โทรศัพท์บ้าน",
                        "โทรศัพท์มือถือ",
                        "วันที่ส่งมอบ",
                        "วันที่มารับมอบ",
                        "วันที่โอน",
                        "สถานะการโอน",
                        "เลขที่เงินกู้",
                        "วงเงินกู้",
                        "เงินงวด",
                        "วันที่ทำสัญญา",
                        "ซื้ออาคารโดย",
                        "อาคาร",
                        "ชั้น",
                        "บ้านเลขที่",
                        "ขนาดห้อง (ตรม.)",
                        "ลบ",
                      ].map((h) => (
                        <th key={h} className="text-left">
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data_import.map((item, index) => {
                      const tdCls = (val) =>
                        val ? "text-left" : "text-left bg-danger-light";
                      return (
                        <tr key={index}>
                          <td className={tdCls(item.full_name)}>
                            {item.full_name || "-"}
                          </td>
                          <td className={tdCls(item.id_card)}>
                            {item.id_card || "-"}
                          </td>
                          <td className={tdCls(item.address)}>
                            {item.address || "-"}
                          </td>
                          <td className="text-left">
                            {item.home_phone || "-"}
                          </td>
                          <td className={tdCls(item.mobile_phone)}>
                            {item.mobile_phone || "-"}
                          </td>
                          <td className="text-left">
                            {item.delivery_date || "-"}
                          </td>
                          <td className="text-left">
                            {item.receive_date || "-"}
                          </td>
                          <td className="text-left">
                            {item.transfer_date || "-"}
                          </td>
                          <td className={tdCls(item.status_transfer)}>
                            {getLabel(TRANSFER_OPTS, item.status_transfer)}
                          </td>
                          <td className="text-left">
                            {item.loan_number || "-"}
                          </td>
                          <td className="text-left">
                            {item.credit_limit || "-"}
                          </td>
                          <td className="text-left">
                            {item.installment || "-"}
                          </td>
                          <td className="text-left">
                            {item.contract_date || "-"}
                          </td>
                          <td className={tdCls(item.status_buy_building)}>
                            {getLabel(BUY_OPTS, item.status_buy_building)}
                          </td>
                          <td className={tdCls(item.address_number)}>
                            {item.address_number || "-"}
                          </td>
                          <td className={tdCls(item.building)}>
                            {item.building || "-"}
                          </td>
                          <td className={tdCls(item.floor)}>
                            {item.floor || "-"}
                          </td>
                          <td className={tdCls(item.room_size)}>
                            {item.room_size || "-"}
                          </td>
                          <td>
                            <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center">
                              <label
                                className="icon mx-2 text-danger pointer"
                                onClick={() => {
                                  let data = [...this.state.data_import];
                                  data.splice(index, 1);
                                  this.setState({
                                    data_import: data.length ? data : null,
                                  });
                                }}
                              >
                                {"\uf2ed"}
                              </label>
                            </label>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            <div className="w-100 d-flex mt-2">
              {!this.state.data_import ? (
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => this.setState({ modal_import: false })}
                >
                  ปิดหน้าต่าง
                </button>
              ) : (
                <>
                  <div className="p-1" style={{ width: "33%" }}>
                    <button
                      className="btn btn-outline-primary w-100"
                      onClick={() => this.setState({ modal_import: false })}
                    >
                      ยกเลิก
                    </button>
                  </div>
                  <div className="p-1" style={{ width: "33%" }}>
                    <button
                      className="btn btn-danger w-100"
                      onClick={() => this.setState({ data_import: null })}
                    >
                      ล้างค่า
                    </button>
                  </div>
                  <div className="p-1" style={{ width: "33%" }}>
                    <button
                      className="btn btn-primary w-100"
                      onClick={this.CreateImport}
                    >
                      นำเข้า
                    </button>
                  </div>
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
